export default "__VITE_ASSET__S4N3Fp40__";